<template >
	<div ref="selectInstance" tabindex="0" v-on:keyup.esc="cancelModal()">
		<div class="backdrop"/>
		<div class="modal-test">
			<div style="display: flex; justify-content: flex-start; gap: 2px; padding: 2px;">
				<button v-on:click="cancelModal()"
					type="button"
					class="btn-confirm"
				>X</button>
				<button v-on:click="doneModal({IDs: selectedInstanceIDs})"
					type="button"
					class="btn-confirm"
				>Done</button>
			</div>
			<CollectionView
				v-bind:activeChild="activeChild"
				v-bind:activeRequest="activeRequest"
				v-bind:authStatus="authStatus"
				v-bind:Collection="modalCollection"
				v-bind:editMode="2"
				v-bind:pauseICollections="pauseICollections"
				v-bind:queries="queries"

				v-bind:windowWidth="windowWidth"

				v-on:addBranch="$emit('addBranch',$event)"
				v-on:addClientBranch="$emit('addClientBranch',$event)"
				v-on:addQuery="$emit('addQuery',$event)"
				v-on:callInstanceMutation="$emit('callInstanceMutation',$event)"
				v-on:callModalCollection="$emit('callModalCollection',$event)"
				v-on:callTool="$emit('callTool',$event)"
				v-on:clearClientInstances="$emit('clearClientInstances',$event)"
				v-on:clientInstanceDisplay="$emit('clientInstanceDisplay',$event)"
				v-on:clientInstanceIsActive="$emit('clientInstanceIsActive',$event)"
				v-on:clientInstanceRequest="$emit('clientInstanceRequest',$event)"
				v-on:clientInstanceResponse="$emit('clientInstanceResponse',$event)"
				v-on:configBranch="$emit('configBranch',$event)"
				v-on:createITrees="$emit('createITrees',$event)"
				v-on:deleteClientBranch="$emit('deleteClientBranch',$event)"
				v-on:deleteNod="$emit('deleteNod',$event)"
				v-on:deleteQuery="$emit('deleteQuery',$event)"
				v-on:editBBuffer="$emit('editBBuffer',$event)"
				v-on:editBuffer="$emit('editBuffer',$event)"
				v-on:emptyTree="$emit('emptyTree',$event)"
				v-on:fixTrees="$emit('fixTrees')"
				v-on:instanceTableWidth="$emit('instanceTableWidth',$event)"
				v-on:pageCounter="$emit('pageCounter',$event)"
				v-on:purgeCollection="$emit('purgeCollection',$event)"
				v-on:queryBtnClick="$emit('queryBtnClick',$event)"
				v-on:queryCreate="$emit('queryCreate',$event)"
				v-on:queryHandler="$emit('queryHandler',$event)"
				v-on:refreshITrees="$emit('refreshITrees')"
				v-on:removeBranch="$emit('removeBranch',$event)"
				v-on:removeCollection="$emit('removeCollection',$event)"
				v-on:createTree="$emit('createTree', $event)"
				v-on:selectITree="$emit('selectITree',$event)"
				v-on:setActiveQuery="$emit('setActiveQuery',$event)"
				v-on:setActiveRequest="$emit('setActiveRequest',$event)"
				v-on:setITreeIsStale="$emit('setITreeIsStale',$event)"
				v-on:setPauseICollections="$emit('setPauseICollections',$event)"
				v-on:setQueryIsStale="$emit('setQueryIsStale',$event)"
				v-on:toggleSelections="$emit('toggleSelections',$event)"
				v-on:setRoot="$emit('setRoot',$event)"
				v-on:setRootInstanceID="$emit('setRootInstanceID',$event)"
				v-on:setTreeIsStale="$emit('setTreeIsStale',$event)"
				v-on:setUseFilters="$emit('setUseFilters',$event)"
				v-on:trigger="$emit('trigger',$event)"
				v-on:updateBranch="$emit('updateBranch',$event)"
				v-on:updateCBFilter="$emit('updateCBFilter',$event)"
				v-on:updatePaths="$emit('updatePaths',$event)"
				v-on:updateTrees="$emit('updateTrees',$event)"
			/>
		</div>
	</div>
</template>

<script>
	// import {v4 as uuidv4} from  'uuid'
	import CollectionView from	'./CollectionView.vue'
	export default {
		name: 'SelectInstance',
		components: {CollectionView},
		props: {
			activeChild:{
				type:Boolean,
				required: false
			},
			activeRequest:{
				type:Boolean,
				required: false
			},
			authStatus:{
				type: Object,
				required: true,
			},
			modalCollection:{
				type:Object,
				required: false
			},
			containerWidth:{
				type:Number,
				required:false
			},
			parentInstance: {
				type: Object,
				required:false
			},
			pauseICollections:{
				type:Boolean,
				required: false
			},
			queries:{
				type:Array,
				required:false
			},
			windowWidth:{
				type: Number,
				required: false
			}
		},
		data: function(){return{}},
		apollo: {},
		methods: {
			cancelModal(){
				this.$emit('removeCollection',{CollectionID:this.modalCollection.ID,refresh:false})//modalVars.parentCollectionID)
			},
			doneModal(){
				// const rootInstanceID = this.modalCollection.editITree.ITrees?.[0]?.iBranch?.Child?.ID ?? null;
				const rootInstanceID = this.modalCollection.modalVars.rootInstanceID
				const selectedInstanceIDs = this.modalCollection.selectedInstanceIDs
				// console.log('doneModal ',
				// 	{rootInstanceID: rootInstanceID, selectedInstanceIDs:selectedInstanceIDs}
				// )
				// exit if nothing selected
				if (selectedInstanceIDs.length == 0 ){
					return
				}
				// rootInstance will be none in the case when a new Instance is being created
				if (rootInstanceID !== "") {
					// rootInstance exist
					// Apply mutation 0.1.1.2 to all selected instances
					selectedInstanceIDs.forEach(ID => {
						const vars = {
							CollectionID: this.modalCollection.modalVars.parentCollectionID,
							ClientInstance: this.modalCollection.modalVars.ClientInstance,
							childInstanceID: rootInstanceID,
							Instance: ID,
							mutationCode: '0.1.1.2'
						};
						this.$emit('callInstanceMutation', vars);
					});
				} else {
					// Apply mutation 1.1.1.2 to the first selected instance
					const firstID = selectedInstanceIDs[0];
					const vars = {
						CollectionID: this.modalCollection.modalVars.parentCollectionID,
						ClientInstance: this.modalCollection.modalVars.ClientInstance,
						childInstanceID: null,
						Instance: firstID,
						mutationCode: '1.1.1.2'
					};
					this.$emit('callInstanceMutation', vars);

					// Apply mutation 0.1.1.2 to the remaining selected instances
					for (let i = 1; i < selectedInstanceIDs.length; i++) {
						const ID = selectedInstanceIDs[i];
						const vars = {
							CollectionID: this.modalCollection.modalVars.parentCollectionID,
							ClientInstance: this.modalCollection.modalVars.ClientInstance,
							childInstanceID: firstID,
							Instance: ID,
							mutationCode: '0.1.1.2'
						};
						this.$emit('callInstanceMutation', vars);
					}
					
				}

				this.$emit('removeCollection', {
					CollectionID: this.modalCollection.ID,
					refresh: true
				});
			},
			focusInput() {
				this.$refs.selectInstance.focus()
			},
			queryHandler(vars){
				this.$emit('queryHandler',vars)
			},
		},
		mounted() {
			this.focusInput()
		},
	}
</script>

<style scoped>

	/* General Styles */
	* {
		box-sizing: border-box;
	}

	td{
		border: 1px solid black;
	}

	.heading{
		font-weight: bold;
		text-align: center;
		font-size: 200%;
	}

	.backdrop {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.5);
		z-index: 100;
	}

	/* The Modal */
	.modal-test {
		position: fixed;
		z-index: 200;
		top: 10%;
/*		left: 5%;*/
/*		width: 90%;*/
		background: white;
	}


</style>